import React from "react";
import { IconProps } from "./IconProps";

const ChevronArrowUp: React.FC<IconProps> = ({
    size = 16,
    color = "#F7F9F9",
    ...props
}) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={size}
            height={size}
            viewBox="0 0 17 16"
            fill="none"
            {...props}
        >
            <path
                d="M5.16663 6.00033L8.49996 2.66699L11.8333 6.00033"
                stroke={color}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default ChevronArrowUp;
